// extracted by mini-css-extract-plugin
export default {"list":"Layout_list__+k638","item":"Layout_item__bb95a"};